/**
 * @desc bind
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierSnBindRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/bind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
